import Img from "gatsby-image"
import * as queryString from "query-string"
import React from "react"
import { Button, Carousel, Col, Container, Jumbotron, Nav, Navbar, Row } from 'react-bootstrap'
import { Helmet } from "react-helmet"
import { FaFacebookF, FaInstagram, FaStar } from 'react-icons/fa'
import '../assets/css/styles.css'
// import Image from "../components/image"
// import SEO from "../components/seo"
import Faq from "../components/faq"
import Layout from "../components/layout"


const IndexPage = ({ data, location }) => {

  // query-string parses the parameters that are contained in the location object;
  const { utm_source, utm_medium, utm_term, utm_content, utm_campaign, fbclid, gclid } = queryString.parse(location.search);

  const param_dict = {
    "utm_source": utm_source,
    "utm_medium": utm_medium,
    "utm_term": utm_term,
    "utm_content": utm_content,
    "utm_campaign": utm_campaign,
    "fbclid": fbclid,
    "gclid": gclid
  }

  console.log(param_dict)

  var param_string = ''

  for (const [key, value] of Object.entries(param_dict)) {
    if (value !== undefined) {
      param_string += `&${key}=${value}`
    }
  }

  return (
    <Layout>
      <Container fluid>
        <Row className="banner">
          <Col>
            <div><b>❤️ 70% OFF WINTER SALE  ❤️</b></div>
            <div><b>FREE UK NEXT DAY DELIVERY 🇬🇧  BUY 2 FOR EXTRA 20% OFF</b></div>
          </Col>
        </Row>
      </Container>
      <Navbar bg="light" expand="lg">
        <Navbar.Brand href="#main">
          <strong>LaziSkin</strong>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" s />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="#faq">FAQ</Nav.Link>
            <Nav.Link href="#reviews">Reviews</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>



      <Container id="main" className="mx-auto my-5">
        <Row>
          <Col xs={12} md={6}>
            <Carousel>
              <Carousel.Item>
                <Img fluid={data.carouselImage1.childImageSharp.fluid} alt="first image" />
              </Carousel.Item>
              <Carousel.Item>
                <Img fluid={data.carouselImage2.childImageSharp.fluid} />
              </Carousel.Item>
              <Carousel.Item>
                <Img fluid={data.carouselImage3.childImageSharp.fluid} />
              </Carousel.Item>
              <Carousel.Item>
                <Img fluid={data.carouselImage4.childImageSharp.fluid} />
              </Carousel.Item>
            </Carousel>
          </Col>
          <Col xs={12} md={6}>
            <Row>
              <Col>
                {/* <h4 className="quotePrimary">"I feel like I'm in a spa" - Cynthia</h4> */}
                <h2><strong>LaziSkin: At-Home Laser Hair Removal</strong></h2>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="rating">
                  <span className="fa fa-star"><FaStar /></span>
                  <span className="fa fa-star"><FaStar /></span>
                  <span className="fa fa-star"><FaStar /></span>
                  <span className="fa fa-star"><FaStar /></span>
                  <span className="fa fa-star"><FaStar /></span>
                  <span className="ratingText">5.0</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="pricing">
                  <p><s>£279.99</s></p>
                  <p><span className="currentPrice">£79.99</span></p>
                  <p>
                    <span className="discountAmount">£200 off</span>
                    <span className="discountPercentage"> (-72%)</span>
                  </p>
                </div>
              </Col>
            </Row>
            <Col>
              <Row>
                <Col className="centerText">
                  <a href={`https://laziskinuk.myshopify.com/cart/31532221366365:1?channel=buy_button${param_string}`}>
                    <Button variant="primary" className="blackButton" size="lg" block>Buy Black</Button>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col className="centerText">
                  <a href={`https://laziskinuk.myshopify.com/cart/29310690000989:1?channel=buy_button${param_string}`}>
                    <Button variant="primary" className="whiteButton" size="lg" block>Buy White</Button>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col className="centerText">
                  <a href={`https://laziskinuk.myshopify.com/cart/29310690033757:1?channel=buy_button${param_string}`}>
                    <Button variant="primary" className="pinkButton" size="lg" block>Buy Rose Gold</Button>
                  </a>
                </Col>
              </Row>
            </Col>
            <Row>
              <p className="paddingTop20">
                <Col className="leftText">
                  <span>100% No-Risk Money Back Guarantee</span>
                </Col>
              </p>
            </Row>
            <Row>
              <Col>
                <Row className="logoBar">
                  <Col>
                    <Img className="ccLogo" fluid={data.ccLogo1.childImageSharp.fluid} alt="credit card acceptance" />
                  </Col>
                  <Col>
                    <Img className="ccLogo" fluid={data.clearpay.childImageSharp.fluid} alt="credit card acceptance" />
                  </Col>
                  <Col>
                    <Img className="ccLogo" fluid={data.klarna.childImageSharp.fluid} alt="credit card acceptance" />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="productDescription">
                <p className="productDescHighlight">
                  Save Yourself Time and Money - NEVER Shave Again.
                </p>
                <p className="productDescription">
                  The LaziSkin Handheld IPL Laser Hair Remover has been designed and tested for safe and effective hair removal at home. We've taken advantage of clinical standard technology, putting it into the LaziSkin Handheld IPL Laser Hair Remover. In as little as 3 minutes, you can remove hair right from the comfort of your own home. No hidden costs. No need to upgrade or purchase refills. Never shave again!
                </p>
                <Carousel>
                  <Carousel.Item>
                    <Img fluid={data.carouselImage5.childImageSharp.fluid} alt="first image" />
                  </Carousel.Item>
                  <Carousel.Item>
                    <Img fluid={data.carouselImage6.childImageSharp.fluid} />
                  </Carousel.Item>
                  <Carousel.Item>
                    <Img fluid={data.carouselImage7.childImageSharp.fluid} />
                  </Carousel.Item>
                  <Carousel.Item>
                    <Img fluid={data.carouselImage8.childImageSharp.fluid} />
                  </Carousel.Item>
                </Carousel>
                <p className="productDescHighlight">
                  Convenient Flash Modes - Shave ANY Body Part.
                </p>
                <p className="productDescription">
                  The single flash mode is perfect for harder to reach, smaller, more delicate areas. Perfect for removing hair from the lip, armpit, bikini or chin. The continuous flash will save you time on those larger areas, such as your legs, thighs, arms, chest and back. Simply click once for a single flash, or hold the button down for a continuous flash.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container >

      <Faq />


      <Container>
        <div
          className="yotpo yotpo-reviews-carousel"
          data-background-color="transparent"
          data-mode="top_rated"
          data-type="both"
          data-count="9"
          data-show-bottomline="1"
          data-autoplay-enabled="1"
          data-autoplay-speed="3000"
          data-show-navigation="1">
        </div>
      </Container>

      <Container id="review">
        {/* <section className="js-cluster-wrapper zpa-yotpo-062-v2 zpa-yotpo-062 cluster-padding-medium zp ba-30491183"
          data-id="30491183" id="6745843">
          <div className="js-cluster zpa-container zp cac-30491183">
            <div className="flex-row">
              <div className="xs-12 zpa-text-center">
                <div className="zp ba-30491182" data-id="30491182" data-block-wrapper="">
                  <div id="yotpo-root"></div>
                  <div className="yotpo yotpo-main-widget"
                    data-product-id="3803122237533"
                    data-name="LaziSkin"
                    data-url="https://www.laziskin.co.uk/products/handheld-ipl-laser-hair-removal"
                    data-image-url="https://cdn.shopify.com/s/files/1/0100/2989/1635/products/Fiverr_-_10.16.19_-_Photo_-_Selects_47_of_57_1.jpg?v=1571943165"
                    data-description="Save money and never shave again!">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <div class="yotpo yotpo-main-widget"
          data-product-id="3803122237533"
          data-name="Handheld IPL Laser Hair Removal"
          data-url="https://www.laziskin.co.uk/products/handheld-ipl-laser-hair-removal"
          data-image-url="https://cdn.shopify.com/s/files/1/0274/9372/8349/products/WHITEIPL_1080x.jpg?v=1569331559"
          data-price="79.99"
          data-currency="GBP"
          data-description="Save money and never shave again with our IPL Laser Hair Remover!">
        </div>
      </Container>

      <Col>
        <Row>
          <Col className="centerText">
            <a href={`https://laziskinuk.myshopify.com/cart/31532221366365:1?channel=buy_button${param_string}`}>
              <Button variant="primary" className="blackButton" size="lg" block>Buy Black</Button>
            </a>
          </Col>
        </Row>
        <Row>
          <Col className="centerText">
            <a href={`https://laziskinuk.myshopify.com/cart/29310690000989:1?channel=buy_button${param_string}`}>
              <Button variant="primary" className="whiteButton" size="lg" block>Buy White</Button>
            </a>
          </Col>
        </Row>
        <Row>
          <Col className="centerText">
            <a href={`https://laziskinuk.myshopify.com/cart/29310690033757:1?channel=buy_button${param_string}`}>
              <Button variant="primary" className="pinkButton" size="lg" block>Buy Rose Gold</Button>
            </a>
          </Col>
        </Row>
      </Col>

      <Jumbotron className="lightCream centerText footerJumble">
        <Container className="footer">
          <Row className="footer-block">
            <Col className="footerImage">
              <Img fluid={data.footerLogo.childImageSharp.fluid} />
            </Col>
          </Row>
          <Row className="footer-block">
            <Col>
              <p className="footer-description">
                The UK's #1 IPL Laser Hair Removal Device
              </p>
            </Col>
          </Row>
          <Row className="footer-block">
            <Col>
              <div className="socialMediaLinks">
                <a className="fa fa-facebook" href="https://facebook.com/IPLLaziSkin" target="_blank" rel="noopener noreferrer"><FaFacebookF /><span>fb</span></a>
                <a className="fa fa-instagram" href="https://instagram.com/laziskinofficial" target="_blank" rel="noopener noreferrer"><FaInstagram /><span>ig</span></a>
              </div>
            </Col>
          </Row>
          <Row className="footer-block">
            <Col>
              <span className="footer-words">
                Designed with <span className="heart">❤</span> in the UK 🇬🇧
              </span>
              <span className="footer-words">
                ©2020 Copyright. All rights reserved
              </span>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
      <Helmet>
        <script defer type="text/javascript">
          {`
          (function e() {
            var e = document.createElement('script');
              e.type = "text/javascript";
              e.async = false;
              e.src = "//staticw2.yotpo.com/sMEblZRzfjS0qcm3G8OoSCpKka9Dhy5Q4vYzeVgo/widget.js";
              var t = document.getElementsByTagName("script")[0];
              t.parentNode.insertBefore(e, t);
            })();
          `}
        </script>
      </Helmet>
    </Layout >
  );

}

export default IndexPage

export const query = graphql`
  query {
    ccLogo1: file(relativePath: { eq: "cc_logos.png" }) {
      childImageSharp {
        fluid(maxWidth: 200) {
          ...GatsbyImageSharpFluid
        }
      }
    }  
    clearpay: file(relativePath: { eq: "clearpay-logo.png" }) {
      childImageSharp {
        fluid(maxWidth: 200) {
          ...GatsbyImageSharpFluid
        }
      }
    }  
    klarna: file(relativePath: { eq: "klarna.png" }) {
      childImageSharp {
        fluid(maxWidth: 200) {
          ...GatsbyImageSharpFluid
        }
      }
    }  
    carouselImage1: file(relativePath: { eq: "white.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    carouselImage2: file(relativePath: { eq: "black.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    carouselImage3: file(relativePath: { eq: "pink.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    carouselImage4: file(relativePath: { eq: "usage.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    carouselImage5: file(relativePath: { eq: "beforeafter.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    carouselImage6: file(relativePath: { eq: "beforeafter2.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    carouselImage7: file(relativePath: { eq: "beforeafter3.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    carouselImage8: file(relativePath: { eq: "beforeafter4.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    footerLogo: file(relativePath: { eq: "lz.png" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }

`
